import { render, staticRenderFns } from "./CertificateProperty.vue?vue&type=template&id=337839f1&scoped=true"
import script from "./CertificateProperty.vue?vue&type=script&lang=js"
export * from "./CertificateProperty.vue?vue&type=script&lang=js"
import style0 from "./CertificateProperty.vue?vue&type=style&index=0&id=337839f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337839f1",
  null
  
)

export default component.exports